module.exports = __webpack_public_path__ + "static/media/Offsite_warning_V2.b93cace0.png";